import { useTypedSelector } from 'src/State/RootReducer'
import { ChartSettings } from '../../editor'
import { CustomLayout } from '../utils'

interface ReturnType {
  chartLayout: CustomLayout
}

/**
 * This hook provides a chart's layout. A layout is either initially set or edited by the user.
 * Only default charts come with an initial layout. Both default and custom chart layouts can be edited.
 */
const useChartLayout = (chartSettingsList: ChartSettings[], initialChartLayout: CustomLayout): ReturnType => {
  const chartLayoutId = initialChartLayout.id ?? ''
  const installationId = useTypedSelector(state => state.storage.activeInstallation)
  const storageId = useTypedSelector(state => state.storage.activeStorage)

  const editedChartLayout = chartSettingsList.find(item => {
    const chartIsSavedInUserSettings = String(item.id) === String(chartLayoutId)
    const chartBelongsToTheSelectedInstallation =
      Number(item.installationId) === Number(installationId) && Number(item.storageSerialNumber) === Number(storageId)

    return chartIsSavedInUserSettings && chartBelongsToTheSelectedInstallation
  })

  if (editedChartLayout) {
    const updatedChartLayout: CustomLayout = {
      ...initialChartLayout,
      views: editedChartLayout.views ?? initialChartLayout.views,
      title: editedChartLayout.name ?? initialChartLayout.title,
      traces: editedChartLayout.traces ?? initialChartLayout.traces,
    }
    return { chartLayout: updatedChartLayout }
  }

  return { chartLayout: initialChartLayout }
}

export default useChartLayout
